import LocalizedStrings, {
  GlobalStrings,
  LocalizedStrings as LocalizedStringsT,
} from "localized-strings";

function withOptions<T>(strings: GlobalStrings<T>): LocalizedStringsT<T> {
  return new LocalizedStrings(strings, {});
}

export const common = withOptions({
  en: {
    rx365: "Rx365",
    register: "Register",
    login: "Login",
    signOut: "Sign Out",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    dateOfBirth: "Date of Birth",
    password: "Password",
    rxNumber: "Rx Number",
    rxNum: "Rx#",
    previousScriptNumber: "Recent Prescription Number",
    whoops: "Whoops!",
    somethingWentWrong: "Something went wrong, please try again later.",
    success: "Success!",
    yes: "Yes",
    no: "No",
    back: "Back",
    submit: "Submit",
    cancel: "Cancel",
    ok: "OK",
    close: "Close",
  },
  es: {
    rx365: "Rx365",
    register: "Registrar",
    login: "Iniciar sesión",
    signOut: "Cerrar sesión",
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Correo electrónico",
    dateOfBirth: "Fecha de nacimiento",
    password: "Contraseña",
    rxNumber: "Núm. de Rx",
    rxNum: "Rx#",
    previousScriptNumber: "Núm. de Rx reciente",
    whoops: "¡Ups!",
    somethingWentWrong: "Algo mal sucedió. Favor de intentar de nuevo después.",
    success: "Éxito",
    yes: "Sí",
    no: "No",
    back: "Atrás",
    submit: "Enviar",
    cancel: "Cancelar",
    ok: "Aceptar",
    close: "Cerrar",
  },
});

export const navLinks = withOptions({
  en: {
    medications: "Medications",
    appointments: "Appointments",
    pharmacy: "Pharmacy",
    profile: "Profile",
  },
  es: {
    medications: "Medicamentos",
    appointments: "Citas",
    pharmacy: "Farmacia",
    profile: "Perfil",
  },
});

// COMPONENTS

export const addInsuranceCardModal = withOptions({
  en: {
    title: "Add Card",
    header: "Add Card Images",
    instructions:
      "Upload a picture of your insurance card, make sure all the text is visible",
    front: "Front",
    back: "Back",
    selectType: "Select a card type",
    save: "Save Changes",
  },
  es: {
    title: "Añadir Tarjeta",
    header: "Añadir Imagenes de la Tarjeta",
    instructions:
      "Suba una foto de su tarjeta de seguro, asegúrese de que todo el texto sea visible",
    front: "Frente",
    back: "Reverso",
    selectType: "Eliga un Tipo de Tarjeta",
    save: "Guardar Cambios",
  },
});

export const confirmAppointmentModal = withOptions({
  en: {
    title: "Confirm Appointment",
    date: "Date",
    noDate: "No date given",
    time: "Time",
    noTime: "No time given",
    comments: "Comments",
    confirmAndBook: "Confirm and Book",
    genericErrorMessage: "There was an error confirming your appointment.",
  },
  es: {
    title: "Confirmar Cita",
    date: "Fecha",
    noDate: "Fecha no especificada",
    time: "Hora",
    noTime: "Hora no especificada",
    comments: "Comentarios",
    confirmAndBook: "Confirmar y Reservar",
    genericErrorMessage: "Hubo un error al confirmar su cita.",
  },
});

export const appointmentConfirmationModal = withOptions({
  en: {
    title: "Success!",
    description: "Your appointment has been scheduled.",
    date: "Date",
    time: "Time",
    continue: "Continue",
  },
  es: {
    title: "¡Completado!",
    description: "Su cita ha sido agendada.",
    date: "Fecha",
    time: "Hora",
    continue: "Continuar",
  },
});

export const confirmDeleteInsuranceCard = withOptions({
  en: {
    header: "Are you sure you want to delete this card?",
    yes: "Yes, delete",
  },
  es: {
    header: "¿Está segur@ de que desea borrar esta tarjeta?",
    yes: "Sí, borrar",
  },
});

export const confirmRefillRequest = withOptions({
  en: {
    title: "Confirm Refill Request",
    qty: "Qty:",
    pickupDay: "Pickup Day",
    selectDate: "Select a date",
    pickupTime: "Pickup Time",
    selectTime: "Select a time",
    requestRefill: "Request Refill",
  },
  es: {
    title: "Confirmar Orden de Surtido",
    qty: "Cantidad:",
    pickupDay: "Día de recogida",
    selectDate: "Seleccione una fecha",
    pickupTime: "Hora de recogida",
    selectTime: "Seleccione una hora",
    requestRefill: "Pedir Relleno",
  },
});

export const datePickerModal = withOptions({
  en: {
    select: "Select",
  },
  es: {
    select: "Seleccionar",
  },
});

export const dateRangeSelect = withOptions({
  en: {
    lastDays: (num: number) => `Last ${num} days`,
    lastMonths: (num: number) => `Last ${num} months`,
    custom: "Custom Date Range",
    selectRange: "Select a Range",
    from: "From",
    to: "to",
    errorMessage: "Ending date must be the same or later than starting date",
  },
  es: {
    lastDays: (num: number) => `Últimos ${num} días`,
    lastMonths: (num: number) => `Últimos ${num} meses`,
    custom: "Rango de fechas",
    selectRange: "Seleccionar un rango",
    from: "Desde",
    to: "Hasta",
    errorMessage:
      "La fecha de finalización debe ser igual o posterior a la fecha de inicio",
  },
});

export const deleteAccountModal = withOptions({
  en: {
    title: "Delete Account",
    warning:
      "Are you sure you want to permanently delete your account? You will no longer be able to access information about your prescriptions, view your medication history, or schedule appointments.",
    deleteAccount: "Delete Account",
    errorMessage: "Error encountered while trying to delete account",
  },
  es: {
    title: "Eliminar cuenta",
    warning:
      "¿Está seguro(a) que desea eliminar su cuenta de forma permanente? No podrá tener acceso a información de sus recetas, ver su historial de medicamentos, o hacer citas.",
    deleteAccount: "Eliminar cuenta",
    errorMessage: "Se encontró un error al intentar eliminar la cuenta",
  },
});

export const dragAndDropFileUpload = withOptions({
  en: {
    remove: "remove uploaded",
  },
  es: {
    remove: "eliminar subido",
  },
});

export const header = withOptions({
  en: {
    menu: "Menu",
  },
  es: {
    menu: "Menú",
  },
});

export const medicationsFilterModal = withOptions({
  en: {
    title: "Medications",
    update: "Update",
    reset: "Reset Filters",
    filterByStatus: "Filter by Status",
    readyForPickup: "Ready for Pickup",
    scheduled: "Order Placed",
    requiresRenewal: "Requires Renewal",
    readyForRefill: "Ready for Refill",
    onFile: "On File",
    inProgress: "In Progress",
  },
  es: {
    title: "Medicamentos",
    update: "Actualizar",
    reset: "Quitar Filtro",
    filterByStatus: "Filtrar por Estado",
    readyForPickup: "Listo para Recoger",
    scheduled: "Pedido Realizado",
    requiresRenewal: "Requiere renovación",
    readyForRefill: "Listo para rellenar",
    onFile: "Fichado",
    inProgress: "En progreso",
  },
});

export const passwordRequirements = withOptions({
  en: {
    distinct: (min: number) => `${min} distinct characters`,
    minimum: (min: number) => `Minimum ${min} total characters`,
    uppercase: "One uppercase letter",
    lowercase: "One lowercase letter",
    number: "One number",
    fulfilled: "Fulfilled",
    unfulfilled: "Unfulfilled",
  },
  es: {
    distinct: (min: number) => `${min} caracteres distintos`,
    minimum: (min: number) => `Mínimo ${min} caracteres en total`,
    uppercase: "Una letra mayúscula",
    lowercase: "Una letra minúscula",
    number: "Un número",
    fulfilled: "Cumplido",
    unfulfilled: "No cumplido",
  },
});

export const refillPlacedModal = withOptions({
  en: {
    refillsPlaced: "Refill(s) Requested. View the results below:",
    success: "Success",
    failure: "Failure",
  },
  es: {
    refillsPlaced:
      "Recarga(s) solicitada(s). Vea los resultados a continuación:",
    success: "Éxito",
    failure: "Falla",
  },
});

export const searchBar = withOptions({
  en: {
    delete: "Delete",
  },
  es: {
    delete: "Borrar",
  },
});

export const textInput = withOptions({
  en: {
    hide: "Hide",
    show: "Show",
  },
  es: {
    hide: "Ocultar",
    show: "Mostrar",
  },
});

export const timePickerModal = withOptions({
  en: {
    select: "Select",
  },
  es: {
    select: "Seleccionar",
  },
});

export const unauthLayout = withOptions({
  en: {
    pillBottle: "Pill Bottle",
  },
  es: {
    pillBottle: "Frasco de pastillas",
  },
});

// PAGES

export const account = withOptions({
  en: {
    title: "Personal Information",
    genericErrorMessage:
      "There was an problem updating your account information. Please try again.",
    save: "Save",
  },
  es: {
    title: "Información Personal",
    genericErrorMessage:
      "Hubo un problema al actualizar la información de su cuenta. Por favor, trate otra vez.",
    save: "Guardar",
  },
});

export const appointmentQuestionnaire = withOptions({
  en: {
    enterAnswer: "Enter your answer here",
    disqualifying: (num: number) =>
      "Disqualifying " + (num === 1 ? "Answer" : "Answers"),
    cancel: "Cancel Appointment Booking",
    title: "Answer Questionnaire",
    review: "Review and Confirm",
  },
  es: {
    enterAnswer: "Ingrese su respuesta aquí",
    disqualifying: (num: number) =>
      "Respuesta descalificatoria " + (num === 1 ? "singular" : "plural"),
    cancel: "Cancelar reserva de cita",
    title: "Contestar Cuestionario",
    review: "Revisar y confirmar",
  },
});

export const appointments = withOptions({
  en: {
    noAppointments: "No Appointments Available",
    noUpcomingAppointments: "No upcoming appointments",
    title: "Appointments",
    next: "Add Appointment",
    invalid:
      "We're sorry, but the appointment option you selected is not available. Please use the options below to view other appointment options.",
  },
  es: {
    noAppointments: "No hay citas disponibles",
    noUpcomingAppointments: "No hay citas futuras",
    title: "Citas",
    next: "Añadir Cita",
    invalid: "TODO",
  },
});

export const appointmentDetails = withOptions({
  en: {
    appointmentDetails: "Appointment Details",
    cancelAppointment: "Cancel Appointment",
    date: "Date",
    time: "Time",
  },
  es: {
    appointmentDetails: "Detalles de la Cita",
    cancelAppointment: "Cancelar Cita",
    date: "Fecha",
    time: "Hora",
  },
});

export const cancelAppointmentModal = withOptions({
  en: {
    confirmCancelation: "Confirm Cancelation",
    confirmText: "Are you sure you would like to cancel this appointment?",
    keepAppointment: "Keep Appointment",
    cancelAppointment: "Cancel Appointment",
    cancelError: "There was an error canceling your appointment.",
  },
  es: {
    confirmCancelation: "Confirmar Cancelación",
    confirmText: "¿Está seguro de que desea cancelar esta cita?",
    keepAppointment: "Mantener Cita",
    cancelAppointment: "Cancelar Cita",
    cancelError: "Hubo un error al cancelar su cita.",
  },
});

export const changePassword = withOptions({
  en: {
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    passwordMatchError: "Passwords do not match. Please try again.",
    fieldsMustMatch: "Fields must match",
    successBody: "Password successfully changed.",
    save: "Save Changes",
    title: "Change Password",
  },
  es: {
    currentPassword: "Contraseña Actual",
    newPassword: "Contraseña Nueva",
    confirmNewPassword: "Confirmar Contraseña Nueva",
    passwordMatchError:
      "Las contraseñas no coinciden. Por favor, inténtelo de nuevo.",
    fieldsMustMatch: "Entradas deben coincidir",
    successBody: "Contraseña cambiada con éxito.",
    save: "Guardar cambios",
    title: "Cambiar contraseña",
  },
});

export const confirmTransfer = withOptions({
  en: {
    details: "Confirm Details",
    patientName: "Patient Name",
    pharmName: "Pharmacy Name",
    pharmPhone: "Pharmacy Phone Number",
    pharmCity: "Pharmacy City",
    pharmState: "Pharmacy State",
    medName: "Medication Name and/or Rx Number",
    successBody: "Your transfer was successful.",
    errorBody: "Transfer could not be processed.",
  },
  es: {
    details: "Confirmar detalles",
    patientName: "Nombre de Paciente",
    pharmName: "Nombre de Farmacia",
    pharmPhone: "Núm. teléfonico de Farmacia",
    pharmCity: "Ciudad de Farmacia",
    pharmState: "Estado de Farmacia",
    medName: "Nombre de Medicamento y/o núm de Receta",
    successBody: "Su transferencia se realizó.",
    errorBody: "No se pudo procesar la transferencia.",
  },
});

export const forgotEmail = withOptions({
  en: {
    title: "Forgot Email",
    description:
      "Enter the details associated with your account below to recover your email",
  },
  es: {
    title: "Olvidé mi correo electrónico",
    description:
      "Entre los detalles asociados con su cuenta abajo para recuperar su correo electrónico",
  },
});

export const forgotPassword = withOptions({
  en: {
    forgotPassword: "Forgot Password",
    instructions: "Enter the email associated with your account",
  },
  es: {
    forgotPassword: "Olvidé mi contraseña",
    instructions: "Entre el correo electrónico asociado con su cuenta",
  },
});

export const home = withOptions({
  en: {
    title:
      "View your medication history, Chat with your pharmacist, Easily order refills",
    guest: "Continue as Guest",
    pillBottle: "Pill bottle",
    termsAndConditions: "Terms and Conditions",
    disabled: "This pharmacy's account has been disabled.",
  },
  es: {
    title:
      "Vea su historial de medicamentos, Hable con su farmacista, Resurta sus medicamentos fácilmente",
    guest: "Continuar como Invitado",
    pillBottle: "Frasco de pastillas",
    termsAndConditions: "Términos y condiciones",
    disabled: "La cuenta de esta farmacia ah sido desactivada.",
  },
});

export const insurance = withOptions({
  en: {
    title: "Insurance Cards",
    description:
      "Scan the front and back of your insurance cards and send this information to your pharmacy.",
    front: "Front",
    back: "Back",
    noCards: "No Cards to Show",
    addCard: "Add Card",
    successBody: "Your changes have been saved.",
  },
  es: {
    title: "Tarjeta de seguro",
    description:
      "Escanee el frente y el reverso de su tarjeta de seguro y envíe esta información a su farmacia.",
    front: "Frente",
    back: "Atrás ",
    noCards: "No hay tarjetas para mostrar",
    addCard: "Añadir Tarjeta",
    successBody: "Sus cambios han sido guardados.",
  },
});

export const loginPage = withOptions({
  en: {
    forgot: "Forgot ",
    or: "or",
    questionMark: "?",
    emailRecovered: "Email Recovered",
    redirected: "Redirected",
    youHaveBeenRedirected:
      "You have been redirected to your home store. If you wish to change your home store, you can do so via the Profile tab after logging in.",
    disabled: "This pharmacy's account has been disabled.",
  },
  es: {
    forgot: "¿Olvidó su ",
    or: "o",
    questionMark: "?",
    emailRecovered: "Correo electrónico recuperado",
    redirected: "Redirijid@",
    youHaveBeenRedirected:
      "Usted ah sido redirijid@ a su farmacia principal. Si you desea cambiar su farmacia principal, lo puede hacer a través de la area Profile después de iniciar.",
    disabled: "La cuenta de esta farmacia ah sido desactivada.",
  },
});

export const medicationRefillUnauth = withOptions({
  en: {
    removeAlt: "remove rxNumber field",
    registerPrompt:
      "View your medication history, Schedule appointments, Easily order refills.",
    rxNumberNotANumber: "Must be a number",
    enterAnother: "Enter another Rx Number",
    requestRefill: "Request Refill",
    errorBody: (numRefills: number) =>
      `There was an error processing your refill ${
        numRefills > 1 ? "requests" : "request"
      }.`,
    title: "Medication Refill",
  },
  es: {
    removeAlt: "eliminar entrada de núm. de Rx",
    registerPrompt:
      "Vea su historial de medicamentos, Pida Citas, Ordene Rellenos Fácilmente.",
    rxNumberNotANumber: "Debe ser un número",
    enterAnother: "Entre otro número de Rx",
    requestRefill: "Pedir relleno",
    errorBody: (numRefills: number) =>
      `Hubo un error al procesar su solicitud de relleno ${
        numRefills > 1 ? "pedidos" : "pedidos"
      }.`,
    title: "Relleno de medicamentos",
  },
});

export const medications = withOptions({
  en: {
    scheduled: "Order Placed",
    processing: "In Progress",
    readyForPickup: "Ready for Pickup",
    outOfRefills: "Out of Refills",
    lastDays: (num: number) => `last ${num} days`,
    lastMonths: (num: number) => `last ${num} months`,
    specifiedDateRange: "specified date range",
    lastFilled: "Last Filled",
    drugName: "Drug Name (A to Z)",
    title: "Your Medications",
    search: "Search by medication, prescriber, Rx number",
    filter: "Filter",
    showMeds: "Show Medications from the last",
    sortBy: "Sort by:",
    refillMultiple: "Refill Multiple",
    invalidDateRange: "Please select a valid date range",
    loadMore: "Load More Medications",
    noMedsIn: "No prescribed medications found within the",
    requestRefill: "Request Refill",
    problemProcessing: "There was an error processing your refill",
    problemLoading: "There was a problem loading your medications.",
    lastFilledOn: "Last Filled On",
    writtenOn: "Written On",
    autoFill: "AutoFill",
    medSync: "MedSync",
  },
  es: {
    scheduled: "Pedido realizado",
    processing: "En progreso",
    readyForPickup: "Listo para recoger",
    outOfRefills: "Sin rellenos disponibles",
    lastDays: (num: number) => `últimos ${num} días`,
    lastMonths: (num: number) => `últimos ${num} meses`,
    specifiedDateRange: "rango de fechas especificado",
    lastFilled: "Resurtido",
    drugName: "Nombre del medicamento (A a Z)",
    title: "Sus medicamentos",
    search: "Buscar por medicamento, doctor, número de Rx",
    filter: "Filtrar",
    showMeds: "Mostrar medicamentos de los últimos",
    sortBy: "Ordenar por:",
    refillMultiple: "Resurtir Múltiples",
    invalidDateRange: "Por favor seleccione un rango de fechas válido",
    loadMore: "Cargar más medicamentos",
    noMedsIn: "No se encontraron medicamentos recetados dentro de los",
    requestRefill: "Pedir Relleno",
    problemProcessing: "Hubo un error al procesar su relleno",
    problemLoading: "Hubo un problema al cargar sus medicamentos.",
    lastFilledOn: "Resturtido el",
    writtenOn: "Escrito el",
    autoFill: "AutoLlenar",
    medSync: "MedSync",
  },
});

export const apptPatientSelect = withOptions({
  en: {
    title: "Patient Selection",
    description: "Which patient is this appointment for?",
    next: "Next",
  },
  es: {
    title: "Patient Selection - TODO",
    description: "Which patient is this appointment for? - TODO",
    next: "Siguiente",
  },
});

export const newAppointment = withOptions({
  en: {
    title: "New Appointment",
    reason: "Reason for Appointment",
    appointmentType: "Appointment Type",
    next: "Next",
  },
  es: {
    title: "Cita Nueva",
    reason: "Seleccione una opción",
    appointmentType: "Tipo de Cita",
    next: "Siguiente",
  },
});

export const appointmentCampaign = withOptions({
  en: {
    title: "Select a",
    next: "Next",
    vaccination: "Vaccination",
    test: "Test",
    consultation: "Consultation",
    obsolete: "Obsolete",
  },
  es: {
    title: "Seleccione",
    next: "Siguiente",
    vaccination: "una Vacuna",
    test: "un Examen",
    consultation: "una Consulta",
    obsolete: "Obsolete",
  },
});

export const appointmentOption = withOptions({
  en: {
    title: "Select an Appointment Option",
    next: "Next",
  },
  es: {
    title: "Seleccione Una Opción",
    next: "Siguiente",
  },
});

export const pharmacy = withOptions({
  en: {
    closed: "Closed",
    contact: "Contact pharmacy for hours of operation",
    openNow: "Open Now",
    closedNow: "Closed Now",
    open: "Open",
    seeFullHours: "See full hours",
    doesNotExist:
      "The pharmacy you are looking for does not seem to exist, please verify the url or try again later.",
    loadingError:
      "Something went wrong while loading the pharmacy, please try again later.",
  },
  es: {
    closed: "Cerrada",
    contact: "Contacte la farmacia para horas de operación",
    openNow: "Abierta ahora",
    closedNow: "Cerrada ahora",
    open: "Abierta",
    seeFullHours: "Ver Horario Completo",
    doesNotExist:
      "La farmacia que busca parece no existir, por favor verifique la URL o trate otra vez más tarde.",
    loadingError:
      "Hubo un error al cargar la farmacia, por favor trate otra vez más tarde.",
  },
});

export const prescriptionDetails = withOptions({
  en: {
    patientPay: "Patient Pay",
    prescriber: "Prescriber",
    quantity: "Quantity",
    supply: "Supply",
    days: "Days",
    contactPharmacy: "Contact Pharmacy",
    refillReadyForPickup: "Your Refill is Ready for Pickup",
    onItsWay: "Your Refill is on its way",
    expectedPickup: "Expected Pickup :",
    processing: "In Progress",
    readyForPickup: "Ready for Pickup",
    requestRefill: "Request Refill",
    instructions: "Instructions",
    fillHistory: "Fill History",
    genericErrorMessage: "There was an error processing your refill",
    orderPlaced: "Order Placed",
    onFile: "On File",
    autoFill: "AutoFill",
    medSync: "MedSync",
    lastFilled: "Last Filled",
    writtenOn: "Written On",
    medicationInformation: "View Medication Information",
    medInfoError1: "Medication information is not available for this product.",
    medInfoError2:
      "Medication Information for this product is unavailable at this time.",
  },
  es: {
    patientPay: "Pago del Paciente",
    prescriber: "Doctor",
    quantity: "Cantidad",
    supply: "Suministro",
    days: "Días",
    contactPharmacy: "Contactar Farmacia",
    refillReadyForPickup: "Su relleno está Listo para Recoger",
    onItsWay: "Su relleno está en camino",
    expectedPickup: "Recogida Esperada:",
    processing: "En Progreso",
    readyForPickup: "Listo para Recoger",
    requestRefill: "Pedir relleno",
    instructions: "INSTRUCCIONES",
    fillHistory: "Historial de Llenados",
    genericErrorMessage: "Hubo un error al procesar su recarga",
    orderPlaced: "Pedido realizado",
    onFile: "Fichado",
    autoFill: "AutoLlenar",
    medSync: "MedSync",
    lastFilled: "Surtido el",
    writtenOn: "Recetado el",
    medicationInformation: "Información de medicamentos",
    medInfoError1:
      "La información de medicamento no esta disponible para este producto.",
    medInfoError2:
      "La información de medicamento para este producto no esta disponible en este momento.",
  },
});

export const profile = withOptions({
  en: {
    title: "Profile",
    pharmacy: "Pharmacy",
    insurance: "Insurance Card",
    tax: "Tax Report",
    transfer: "Transfer In",
    account: "Account",
    personal: "Personal Information",
    changePassword: "Change Password",
    deleteAccount: "Delete Account",
  },
  es: {
    title: "Perfil",
    pharmacy: "Farmacia",
    insurance: "Tarjeta de Seguro",
    tax: "Reporte de Impuestos",
    transfer: "Transferir Receta",
    account: "Perfil de Usuario",
    personal: "Información Personal",
    changePassword: "Cambiar Contraseña",
    deleteAccount: "Borrar Cuenta",
  },
});

export const profileUnauth = withOptions({
  en: {
    description:
      "View your medication history, Schedule appointments, Easily order refills",
  },
  es: {
    description:
      "Vea su historial de medicamentos, Pida Citas, Ordene Rellenos Fácilmente.",
  },
});

export const registerPage = withOptions({
  en: {
    confirmPassword: "Confirm Password",
    passwordMatchError: "Passwords do not match. Please try again",
    mustMatch: "Fields must match",
    genericErrorMessage: "There was a problem processing your register request",
  },
  es: {
    confirmPassword: "Confirmar contraseña",
    passwordMatchError:
      "Las contraseñas no coinciden. Por favor, trate otra vez",
    mustMatch: "Entradas deben coincidir",
    genericErrorMessage: "Hubo un problema procesando su registro",
  },
});

export const resetPassword = withOptions({
  en: {
    resetPassword: "Reset Password",
    description:
      "Check your email for a reset code and enter it below, along with your new password",
    resetCode: "Reset code",
    newPassword: "New password",
    successBody: "Your password has been reset. Please continue to login.",
    returnToLogin: "Return to Login",
  },
  es: {
    resetPassword: "Restablecer Contraseña",
    description:
      "Revise su correo electrónico por un código de restablizo y entrelo abajo, junto con su nueva contraseña",
    resetCode: "Código de Restablizo",
    newPassword: "Nueva Contraseña",
    successBody:
      "Su contraseña a sido restablizada. Por favor continue para iniciar.",
    returnToLogin: "Regresar a Inicio",
  },
});

export const scheduleAppointment = withOptions({
  en: {
    title: "Schedule Appointment",
    date: "Date",
    selectDate: "Select a Date",
    time: "Time",
    selectTime: "Select a Time",
    continue: "Continue",
  },
  es: {
    title: "Pedir Cita",
    date: "Fecha",
    selectDate: "Seleccione una fecha",
    time: "Hora",
    selectTime: "Seleccione una hora",
    continue: "Continuar",
  },
});

export const taxReport = withOptions({
  en: {
    title: "Tax Report",
    prompt:
      "Please select the patient, and desired start and end date for your financial report.",
    patientName: "Patient Name",
    startingDate: "Starting Date",
    endingDate: "Ending Date",
    invalidDates: "Ending date must be the same or later than starting date",
    noReportsFound: "No reports could be found in the selected time period.",
    genericErrorMessage:
      "An unexpected error occurred while obtaining the report. Please try again later.",
    view: "View Report",
  },
  es: {
    title: "Reporte de Impuestos",
    prompt:
      "Favor de seleccionar al paciente, el principio y fin del rango de fechas que desea para su reporte de impuestos.",
    patientName: "Nombre de Paciente",
    startingDate: "Fecha de inicio",
    endingDate: "Fecha de finalización",
    invalidDates:
      "La fecha de finalización debe ser la misma o posterior a la fecha de inicio",
    noReportsFound: "No se encontran reportes entre sus fechas eligidas.",
    genericErrorMessage:
      "Un error inesperado ocurrió mientra se obtubo el reporte. Por favor trate otra vez después.",
    view: "Ver Reporte",
  },
});

export const transferPharmacy = withOptions({
  en: {
    medName: "Medication Name and/or Rx Number",
    title: "Transfer In",
    description:
      "Transfer your prescriptions to this pharmacy. Enter your old pharmacy's information and the medication names and/or Rx Numbers for the prescriptions that you want transferred.",
    outgoing: "Transfer From Pharmacy",
    pharmName: "Pharmacy Name",
    pharmPhone: "Pharmacy Phone Number",
    pharmCity: "Pharmacy City",
    pharmState: "Pharmacy State",
    enterAnother: "Enter Another Medication",
    review: "Review",
  },
  es: {
    medName: "Nombre del medicamento y/o núm. de Rx",
    title: "Transferir",
    description:
      "Transfiera sus prescripciones a esta farmacia. Escriba la información de su farmacia anterior y los nombres de los medicamentos o números Rx de las prescripciones que desea transferir.",
    outgoing: "Transferir de la Farmacia",
    pharmName: "Nombre de la farmacia",
    pharmPhone: "Número de teléfono de la farmacia",
    pharmCity: "Ciudad de la farmacia",
    pharmState: "Estado de la farmacia",
    enterAnother: "Añadir otro número Rx",
    review: "Revisar",
  },
});

export const unauthAppointments = withOptions({
  en: {
    title: "Create New Appointment",
    description:
      "Registering an account will allow you to better manage your upcoming appointments and more quickly book appointments in the future.",
    guest: "Continue as guest",
    noAppointmentsAvailable: "No Appointments Available",
    invalid:
      "We're sorry, but the appointment option you selected is not available. Please use the options below to view other appointment options.",
  },
  es: {
    title: "Crear Nueva Cita",
    description:
      "El  registro de una cuenta le permitirá manejar sus próximas citas y poder pedir citas más fácil en el futuro.",
    guest: "Continuar como Invitado",
    noAppointmentsAvailable: "No Hay Citas Disponible",
    invalid:
      "Lo sentimos, pero la opción de cita que seleccionó, no está disponible. Favor de seleccionar una de estas opciones disponibles.",
  },
});

export const guestAppointmentInfo = withOptions({
  en: {
    title: "Your Information",
    phone: "Phone Number",
    street: "Street Address",
    city: "City",
    state: "State",
    zip: "Zip Code",
    addCard: "Add Card",
    updateCard: "Update Card",
    provideInsurance: "Please provide prescription insurance",
    doNotHaveInsurance: "I do not have insurance",
  },
  es: {
    title: "Su Información",
    phone: "Número teléfonico",
    street: "Dirección",
    city: "Ciudad",
    state: "Estado",
    zip: "Código Postal",
    addCard: "Añadir Tarjeta",
    updateCard: "Actualizar Tarjeta",
    provideInsurance: "Favor de proveer seguro de prescripciones",
    doNotHaveInsurance: "No tengo seguro",
  },
});

export const verify = withOptions({
  en: {
    genericSelectionErrorMessage:
      "There was a problem processing your selection",
    successSelectionMessage: (selection?: string | null) =>
      `Your code has been resent to ${selection ?? "your selected method"}`,
    successVerifyMessage:
      "You have successfully verified your account. Click below to log in",
    continue: "Continue to Log In",
    genericVerifyErrorMessage: "There was a problem verifying your account",
    emailPrompt: "Send an email to",
    textPrompt: "Send a text message to",
    step0Instructions:
      "To complete your account registration, you must verify your account. Please select your verification method below:",
    sendVerification: "Send Verification",
    step1Instructions: (selection?: string | null) =>
      `Please enter the verification code that was sent to ${
        selection ?? "your selected method"
      }`,
    enterCode: "Enter Code",
    resendCode: "Resend Code",
    verifyAccount: "Verify Account",
  },
  es: {
    genericSelectionErrorMessage: "Hubo un problema al procesar su selección",
    successSelectionMessage: (selection?: string | null) =>
      `Se ha reenviado su código a ${selection ?? "su método seleccionado"}`,
    successVerifyMessage:
      "Ha verificado su cuenta correctamente. Haga clic a continuación para iniciar sesión",
    continue: "Continuar con iniciar sesión",
    genericVerifyErrorMessage: "Hubo un problema al verificar su cuenta",
    emailPrompt: "Enviar un correo electrónico a",
    textPrompt: "Enviar un mensaje de texto a",
    step0Instructions:
      "Para completar su registro de cuenta, debe verificar su cuenta. Por favor seleccione su método de verificación a continuación:",
    sendVerification: "Enviar verificación",
    step1Instructions: (selection?: string | null) =>
      `Ingrese el código de verificación que se envió a ${
        selection ?? "su método seleccionado"
      }`,
    enterCode: "Ingresar código",
    resendCode: "Reenviar código",
    verifyAccount: "Verificar cuenta",
  },
});

export const yourPharmacy = withOptions({
  en: {
    title: "Your Pharmacy",
  },
  es: {
    title: "Su farmacia",
  },
});
